/* Компонент раздела "Финансы" мобильной версии */
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import {
    IFormatedArrayWithService,
    IPay,
    IPayment,
    // IPaySystem,
    IResponseTypePaySystem,
    // IServicePayment,
} from '../../interfaces/payment.interfaces';
import { IPatient } from '../../interfaces/patient.interfaces';
import { PaymentsService } from '../../services/payments.service';
import { PatientService } from '../../services/patient.service';
import { AlertService } from 'src/lib/ariadna/alert';

import { LoadService } from '../../services/application/load.service';
import { Title } from '@angular/platform-browser';
import { IPeriod } from 'src/app/interfaces/period.interfaces';
import { DateTime } from 'luxon';
import { Utils } from 'src/app/services/utils';
import {
    formatUiDate,
    formatUiDateTime,
    toDateTime,
} from 'src/app/shared/date/date.utils';
import {
    onIfAnimation,
    topButtonAnimation,
} from '../../animations/show-left-right.animation';
import {
    expandedAnimation,
    heightAnimation,
} from '../../animations/height.animation';
import {
    getStrEnd,
    getTekDay,
    getNameDay,
    getTime,
    strToDate,
    getDayWithYear,
} from '../application/global.function';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PayDetailsDialogComponent } from './dialogs/pays-details-dialog/pay-details-dialog.component';
import { PayPeriodDialogComponent } from './dialogs/pay-period-dialog/pay-period-dialog.component';
import { IDateRange } from 'src/app/interfaces/date-range.interfaces';
import { RefundComponent } from 'src/app/modals/refund/refund.component';
import { RecordService } from 'src/app/services/record.service';
import { lastValueFrom } from 'rxjs';
import { Store } from 'src/app/services/store.service';
import { PatInfoForPayModalComponent } from 'src/app/modals/pat-info-for-pay/for-pay.component';
import type { ILoyalCard } from './interfaces';

@Component({
    selector: 'app-payments',
    templateUrl: './payments.component.html',
    styleUrls: ['./payments.component.scss'],
    animations: [
        topButtonAnimation,
        heightAnimation,
        expandedAnimation,
        onIfAnimation,
    ],
    standalone: false,
})
export class PaymentsComponent implements OnInit, OnDestroy {
    @ViewChild('inputFocus') public inputFocusRef!: ElementRef;
    @ViewChild('inputFocus2') public inputFocusRef2!: ElementRef;
    @ViewChild('mymyselect') public mymyselect!: any;
    @ViewChild('paymentsContainer')
    public paymentsContainer!: ElementRef;
    @HostListener('window:scroll', ['$event'])
    public animState = 'on';
    public payAvansAnimeStatus = 0; // закрыта форма оплаты баланса
    public dtBegin: Date | null = null; // Дата начала
    public dtEnd: Date | null = null; // Дата ококнчания
    public dtBegins: Date | null = null;
    public dtEnds: Date | null = null;
    public isLoading = false;
    public paymentsList: IPayment[] | null = null; // Список платежей
    public animateStateServices: string[] = []; // Статус анимации для услуг
    private _patient!: IPatient;
    public payParam: IPay = { phone: '', email: '', sum: 0, abon_id: 0 }; // Данные для создания платежа
    public paymentsListLength: number = 0; // Сколько всего записей
    public countRecToPage = 15; // Количетсво записей на странице mobile
    public paySystem: IResponseTypePaySystem | null = null; // Тип платежной системы
    public lpuList: Array<number> = []; // Список ЛПУ доступных платежных систем
    // paySystemField: string = '';
    public date!: IDateRange;
    //новые переменные
    public periodText = '';
    public loadingMoreContent = false;
    public payPages: Array<IPayment[]> = [];
    public countOfPages = 0;
    public loadedPages = 1;
    public viewPage = 0;
    public servicesListLength: number = 0;
    public showMyContainer: boolean = false;
    public showMyPay: boolean = false;
    public dt_begin = this.dtBegin;
    public dt_end = this.dtEnd;
    public visibill: boolean = false;
    public scrolled: boolean = false;
    private resizeHandler!: () => void;
    public isMobile: boolean = false;
    public selectedButton: 'today' | '3days' | 'all' | null = 'all';
    public isLoyaltyCardCollapsed = false;
    public loyaltyCard: ILoyalCard = {
        number_card: null,
        name_programm: null,
        discount: null,
        bonus_amount: null,
    };
    /**ВАЖНО paymentStatus
     * 0 – услуга бесплатная
     * 1 – услуга платная, отложенный платёж не создан
     * 2 – услуга платная, создан отложенный платёж, но не оплачен
     * 3 – оплачено, услуга платная.
     */

    public priceMapper = {
        '=0': 'рублей',
        '=1': 'рубль',
        '=2': 'рубля',
        other: 'рублей',
    };
    public servicesMapper = {
        '=0': 'услуг',
        '=1': 'услуга',
        '=2': 'услуги',
        other: 'услуг',
    };
    //pc version
    public page = 1;
    public loadingPaymentsList = false; // Загрузка
    public countRectoPage = 15; // Количетсво записей на странице
    public scrollTimeout: any = null;
    public isLoyaltyCardVisible = false;
    public payButtonToUnnesSrv: boolean = false; // принимает параметр, отвечающий за отображ. кнопки оплатить для платных услуг, не обязательных к онлайн оплате

    /* Инициализация компонента */
    public constructor(
        private paymentsService: PaymentsService,
        private patientService: PatientService,
        private alert: AlertService,
        private load: LoadService,
        private dialog: MatDialog,
        private title: Title,
        private rs: RecordService,
        private cdr: ChangeDetectorRef,
    ) {
        const tmpTitle =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.PAYMENTS.TITLE;
        if (tmpTitle) this.title.setTitle(tmpTitle);
        this.date = { dt_begin: new Date(), dt_end: new Date() };
        this.payButtonToUnnesSrv =
            !!load.configData?.CLIENT_SETTINGS.OTHER
                .IS_SHOW_PAY_BUTTON_TO_UNNECESSARY_SRV;
    }

    /** Действия при инициализации компонента */
    public ngOnInit(): void {
        const token = Store.getTokenFromCookie();
        Store.getDataString('ParentCookieName')
            ? this.getPatientInfo(true, token!)
            : this.getPatientInfo();

        this.date.dt_begin?.setDate(this.date.dt_begin.getDate() - 365);
        this.isMobile = window.innerWidth <= 767;

        // Правильная инициализация пагинации
        this.loadedPages = 1;
        this.viewPage = 1;

        this.dtBegins = new Date();
        this.dtBegins.setDate(this.dtBegins.getDate() - 365);
        this.dtEnds = new Date();

        const bonusSystemTypes =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.PAYMENTS
                .BONUS_SYSTEM_TYPES;
        this.isLoyaltyCardVisible = bonusSystemTypes === 'visible';

        // РАЗДЕЛЯЕМ ЛОГИКУ ДЛЯ МОБИЛЬНОЙ И ДЕСКТОПНОЙ ВЕРСИЙ

        if (this.isMobile) {
            this.initMobileData();
        } else {
            this.initDesktopData();
        }

        this.resizeHandler = () => {
            this.isMobile = window.innerWidth <= 767;
        };

        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('scroll', () => this.onScroll());
    }

    public ngOnDestroy() {
        window.removeEventListener('scroll', () => this.onScroll());
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }

    private async initMobileData() {
        this.isLoading = true;
        await this.getPaySystem();
        try {
            await this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            });
            this.formatDateToString(this.date);
        } finally {
            this.isLoading = false;
        }
    }

    // Исправленный метод для десктопной версии
    private async initDesktopData() {
        try {
            await this.getPaySystem(); // Тип платежной системы

            // Устанавливаем правильные даты для десктопа
            this.dtBegin = new Date();
            this.dtBegin.setDate(this.dtBegin.getDate() - 365);
            this.dtEnd = new Date();

            this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
        } catch (error) {
            this.alert.warn('Ошибка при загрузке страницы.');
        }
    }

    public canLoadNextPage(): boolean {
        return (
            !this.loadingMoreContent &&
            !this.loadingPaymentsList &&
            this.loadedPages < this.countOfPages
        );
    }
    public getPatientInfo(isFamilyAccount = false, tokenValue?: string) {
        const result = lastValueFrom(
            this.patientService.getServerPatientInfo$(
                tokenValue,
                isFamilyAccount,
            ),
        );
        result
            .then((info) => {
                this._patient = info;
                this.payParam.email = info.email;
                this.payParam.phone = info.phone;

                this.loyaltyCard = {
                    number_card: info.userCardInfo?.numberCard || null,
                    name_programm: info.userCardInfo?.nameProgramm || null,
                    discount: info.userCardInfo?.discount || null,
                    bonus_amount: info.userCardInfo?.bonusAmount || null,
                };
                this.cdr.detectChanges();
            })
            .catch((error) => console.error('getPatientInfo', error));
    }

    public get isLoyaltyCardInactive(): boolean {
        const card = this.loyaltyCard;
        return card.discount === null && card.bonus_amount === null;
    }

    /** Получение типа платежной системы (телефон или почта) */
    public async getPaySystem() {
        this.paySystem = null;

        try {
            const info = await this.paymentsService.getPaySystem();

            this.paySystem = info;
            if (info.data)
                this.lpuList = info.data.map((item) => item.systemLpuId);
        } catch (error) {
            console.error('Ошибка во время определения платёжной системы');
        }
    }

    //computed boolean function для возвратов
    public isNotRefundPayment(payInfo: IPayment): boolean {
        return (payInfo.allAmount || 1) > 0;
    }

    /** Показ блока с платёжной информацией */
    public showPay() {
        if (this.animState === 'on') {
            this.animState = 'off';
        } else {
            this.animState = 'on';
        }
    }

    /** Оплата, абонемент toggle */
    public ShowTogglePopup(): void {
        this.showMyContainer = !this.showMyContainer;
        if (this.showMyPay === false) {
            setTimeout(() => {
                this.mymyselect.open();
            }, 0);
        }
    }

    /** Скрытие/показ платёжного попапа */
    public ShowTogglePopupPay(): void {
        this.showMyContainer = !this.showMyContainer;

        if (this.showMyContainer === true) {
            setTimeout(() => {
                this.inputFocusRef.nativeElement.focus();
            }, 0);
        }
    }

    /** Оплатить */
    public toPayPc(pay: IPayment) {
        if (pay.confirmationUrl && pay.confirmationUrl.length > 5) {
            window.open(pay.confirmationUrl);
        }
    }

    /** Возможна ли оплата */
    public isPayPc(pay: IPayment): boolean {
        if (
            pay.confirmationUrl &&
            pay.confirmationUrl.length > 5 &&
            [1, 2].includes(pay.paymentStatus)
        ) {
            return true;
        } else {
            return false;
        }
    }

    // Todo: Убрать эти анимации. Или просто заменить их на более короткие.
    /** Показать/скрыть услуги */
    public showHideListservicesPc(index: number) {
        if (this.animateStateServices) {
            if (this.animateStateServices[index] === 'off') {
                this.animateStateServices[index] = 'on';
            } else {
                this.animateStateServices[index] = 'off';
            }
        }
    }

    /** Получение количества услуг */
    public async getServicesSize() {
        this.paymentsList = null;
        this.loadingMoreContent = true;

        try {
            const res = await lastValueFrom(
                this.paymentsService.getPaymentsSize(
                    this.date.dt_begin,
                    this.date.dt_end,
                ),
            );

            if (res.size) {
                this.servicesListLength = res.size;
            } else {
                this.servicesListLength = 0;
            }

            this.setCountOfPages();

            // Загружаем первую страницу данных
            if (this.servicesListLength > 0) {
                await this.loadMoreServices(1, this.countRecToPage);
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке записей');
        } finally {
            this.loadingMoreContent = false;
        }
    }

    /** Изменение периода для вывода записей*/
    public async changePeriod(dateRange: IDateRange) {
        this.date = dateRange;

        this.payPages = [];
        this.paymentsList = null;

        await this.getServicesSize();
        this.formatDateToString(this.date);
        this.periodText = this.getPeriodText(this.date);

        this.loadedPages = 1;
        this.viewPage = 1;
    }
    /** Подгрузка дополнительного кал-ва услуг */
    public async loadMoreServices(pStart?: number, pEnd?: number) {
        try {
            const res = await lastValueFrom(
                this.paymentsService.getPayments(
                    this.date.dt_begin,
                    this.date.dt_end,
                    pStart,
                    pEnd,
                ),
            );

            res.forEach((item) => {
                item.dtSort = strToDate(item.ptDatStr);
                this.setCanPay(item);
            });

            if (res && res.length > 0) {
                // Для первой загрузки или сброса
                if (pStart === 1) {
                    this.payPages = [res];
                    this.paymentsList = [...res];
                } else {
                    // Для последующих загрузок
                    this.payPages.push(res);
                    this.paymentsList = this.paymentsList
                        ? [...this.paymentsList, ...res]
                        : [...res];
                }
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка платежей');
            console.error(error);
            throw error;
        }
    }

    public async loadNextPage() {
        // Проверяем условия для загрузки следующей страницы
        if (
            this.loadingMoreContent ||
            this.loadedPages >= this.countOfPages ||
            this.loadingPaymentsList
        ) {
            return;
        }

        try {
            // Устанавливаем флаг загрузки сразу
            this.loadingMoreContent = true;

            // Увеличиваем счетчики только после начала загрузки
            this.loadedPages++;

            // viewPage увеличиваем только для мобильной версии
            if (this.isMobile) {
                this.viewPage++;
            }

            // Мобильная версия - добавляем к существующим данным
            await this.loadMoreServices(
                this.loadedPages * this.countRecToPage -
                    this.countRecToPage +
                    1,
                this.loadedPages * this.countRecToPage,
            );
        } catch (error) {
            console.error('Error loading next page:', error);

            // Откатываем счетчики при ошибке
            this.loadedPages--;
            if (this.isMobile) {
                this.viewPage--;
            }

            this.alert.error('Не удалось загрузить данные', 3000);
        } finally {
            // Сбрасываем флаги загрузки
            this.loadingMoreContent = false;
        }
    }

    private setCanPay(item: IPayment): void {
        let payEnableDate = item.dtSort;
        let createPayOrder = false;

        item.services?.forEach((itemS) => {
            if (itemS.dtStr && itemS.dtStr.length > 10) {
                itemS.dt = strToDate(itemS.dtStr);

                if (
                    !payEnableDate ||
                    itemS.dt.getTime() > payEnableDate.getTime()
                ) {
                    payEnableDate = itemS.dt;
                }
            }

            if (itemS.isCreatePayOrder === '1') createPayOrder = true;
        });
        if (
            payEnableDate &&
            toDateTime(payEnableDate).toMillis() >
                DateTime.local().toMillis() &&
            (createPayOrder ||
                (this.paySystem &&
                    (this.lpuList.length === 1 ||
                        this.lpuList.includes(item.lpuId)) &&
                    this.payButtonToUnnesSrv))
        ) {
            item.canPay = true;
        } else item.canPay = false;
    }

    /** Вызов диалога с деталями услуги */
    public showDetailsDialog(serv: IPayment) {
        const detailsDialog = this.dialog.open(PayDetailsDialogComponent, {
            maxWidth: '100%',
            maxHeight: '100%',
            panelClass: 'payModalDialog',
            data: {
                service: serv,
            },
        });

        detailsDialog.afterClosed().subscribe((result) => {});
    }

    //надо добавить в массив и отсортировать
    /** манипуляции с датой */
    public isBlockYeerPc(index: number): boolean {
        let f = false;

        if (this.paymentsList?.[index - 1]) {
            if (
                this.paymentsList[index].dtSort?.getFullYear() !==
                this.paymentsList[index - 1].dtSort?.getFullYear()
            ) {
                f = true;
            }
        }
        if (index === 0) {
            f = true;
        }

        return f;
    }

    /** Получение года платежа по его порядковому номеру */
    public getYeerPc(index: number): string {
        if (this.paymentsList?.[index] && this.paymentsList?.[index].ptKeyId) {
            return this.paymentsList[index].dtSort?.getFullYear() + '';
        } else {
            return '';
        }
    }
    /** Установка количества страниц*/
    public setCountOfPages() {
        this.countOfPages = Math.ceil(
            this.servicesListLength / this.countRecToPage,
        );
    }
    public getDateTimeFuul(dt: Date): string {
        return formatUiDateTime(dt);
    }

    /** Получение даты в формате "D MM" */
    public getTekDayPc(dt: Date | undefined): string {
        return getTekDay(dt);
    }

    /** Получение дня недели */
    public getNameDayPc(dt: Date | undefined): string {
        return getNameDay(dt);
    }

    /** Получение времени формата "D MM YYYY" */
    public getDayWithYear(dtSort: Date) {
        return getDayWithYear(dtSort);
    }

    /** Получение времени формата "HH:mm" */
    public getTimePc(dt: Date | undefined): string {
        return getTime(dt);
    }

    /** Получение периода с полным названием месяца */
    public formatDateToString(dt: IDateRange) {
        if (dt.dt_begin) {
            dt.str_begin = formatUiDate(dt.dt_begin);
        }
        if (dt.dt_end) {
            dt.str_end = formatUiDate(dt.dt_end);
        }
    }

    /** строку в число */
    public numberOnlyReplacePc(str: string): number {
        let resNum = '';
        let i = 0;
        let charCode = 0;
        for (i = 0; i < str.length; i++) {
            charCode = str.charCodeAt(i);
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode != 46
            ) {
            } else {
                resNum = resNum + str[i];
            }
        }
        return Number(resNum);
    }

    /*Для Календаря*/

    /** Вызов диалога для выбора периода */
    public showPeriodDialog() {
        const periodDialog = this.dialog.open(PayPeriodDialogComponent, {
            maxWidth: '650px',
            width: '100%',
            height: '100%',
            data: {
                dateRange: {
                    dt_begin: this.date.dt_begin,
                    dt_end: this.date.dt_end,
                } as IDateRange,
            },
        });

        periodDialog.afterClosed().subscribe((result: { date: IDateRange }) => {
            if (result?.date) {
                this.isLoading = true;
                this.changePeriod(result.date).then(
                    () => (this.isLoading = false),
                );
            }
        });
    }

    /** Полученеи текста из периода */
    public getPeriodText(dt: IDateRange) {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin == dt.str_end;

        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'Платежи за всё время';
            else if (dt.dt_begin?.toDateString() == new Date().toDateString())
                periodText = 'Последние платежи';
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.dt_begin && dt.dt_end) {
            const yearAgo = toDateTime(dt.dt_end).minus({ years: 1 });
            if (yearAgo.toMillis() === toDateTime(dt.dt_begin).toMillis()) {
                periodText = `За 1 год`;
            } else {
                periodText = `${dt.str_begin} - ${dt.str_end}`;
            }
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }
        return periodText;
    }

    /**
     * Фильтрация записей по дате
     * @param {number | null} startOffset Сдвиг даты С
     * @param {number | null} endOffset Сдвиг даты ПО
     */
    public btnFilterByDate(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.date.dt_begin = new Date();
            this.date.dt_begin.setDate(
                this.date.dt_begin.getDate() - startOffset,
            );
            this.date.dt_end = new Date();
            this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
            this.isLoading = true;
            this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            }).then(() => (this.isLoading = false));
        } else {
            this.date.dt_begin = null;
            this.dt_begin = this.date.dt_begin;
            this.date.dt_end = null;
            this.dt_end = this.date.dt_end;
            this.isLoading = true;
            this.changePeriod({ dt_begin: null, dt_end: null }).then(() => {
                this.isLoading = false;
            });
        }
    }
    //pc version
    public async initData() {
        try {
            this.getPaySystem(); // Тип платежной системы

            this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
        } catch (error) {
            this.alert.warn('Ошибка при загрузке страницы.');
        }
    }

    /** Получить тип платежной системы телефон почта !*/
    public async getPaySystemPc() {
        this.paySystem = null;
        // this.paySystemField = '';

        try {
            const info = await this.paymentsService.getPaySystem();
            this.paySystem = info;

            // if (info.length > 0) {
            //     this.paySystem = info[0];
            //     // this.paySystemField = this.paySystem.requiredFields;
            // }
        } catch (error) {
            this.alert.warn(
                'Ошибка при получении информации о платёжной системе',
            );
        }
    }

    /** За сегодня */
    public btnFiltrTek() {
        this.dtBegin = new Date();
        this.dtEnd = new Date();
        // this.selectedButton = this.selectedButton === 'today' ? null : 'today';
        this.selectedButton = 'today';
        this.customDateSelected = false;
        this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
    }

    /** За 3 дня */
    public btnFiltr3Day() {
        this.dtBegin = new Date();
        // this.selectedButton = this.selectedButton === '3days' ? null : '3days';
        this.selectedButton = '3days';
        this.customDateSelected = false;
        this.dtBegin.setDate(this.dtBegin.getDate() - 3);
        this.dtEnd = new Date();
        this.changePeriodPc({ begin: this.dtBegin, end: this.dtEnd });
    }
    public btnAllDays() {
        this.dtBegin = new Date(2000, 0, 1);
        this.dtEnd = new Date();
        // this.selectedButton = this.selectedButton === 'all' ? null : 'all';
        this.selectedButton = 'all';
        this.customDateSelected = false;
        this.changePeriodPc({
            begin: this.dtBegin,
            end: this.dtEnd,
        });
    }

    public changePeriodPc(dt: IPeriod) {
        // Добавьте проверку, чтобы избежать лишних запросов
        if (this.loadingPaymentsList) {
            return;
        }

        if (dt.begin !== null && dt.end !== null) {
            this.dtBegins = dt.begin;
            this.dtEnds = dt.end;
        }
        this.getPaymentsSizePC();
        this.page = 1;
    }
    public customDateSelected = false;
    public onDateRangeChanged(period: IPeriod) {
        // Обновляем начало и конец периода
        this.dtBegins = period.begin;
        this.dtEnds = period.end;
        this.customDateSelected = true;
        this.selectedButton = 'all';

        // Перезагружаем список платежей
        this.getPaymentsSizePC();
    }

    /** Количество платежей */
    public async getPaymentsSizePC() {
        this.paymentsList = null;
        this.loadingPaymentsList = true;
        try {
            const results = await lastValueFrom(
                this.paymentsService.getPaymentsSize(
                    this.dtBegins,
                    this.dtEnds,
                ),
            );

            if (results.size) {
                this.paymentsListLength = results.size;
                await this.getPayments(1, this.countRectoPage);
            } else {
                this.paymentsList = [];
                this.paymentsListLength = 0;
                this.loadingPaymentsList = false;
                // await this.getPayments();
            }
        } catch (error) {
            this.alert.warn('Ошибка при получении количества записей');
        }
    }

    /** Список платежей */
    public async getPayments(pStart?: number, pEnd?: number) {
        this.animateStateServices = [];
        let payEnableDate: Date;
        let createPayOrder: boolean = false;

        try {
            const res = await lastValueFrom(
                this.paymentsService.getPayments(
                    this.dtBegins,
                    this.dtEnds,
                    pStart,
                    pEnd,
                ),
            );

            res.forEach((item) => {
                item.dtSort = strToDate(item.ptDatStr);
                this.setCanPay(item);
            });
            this.paymentsList = res || [];
            this.animateStateServices.push('off');
        } catch (error) {
            this.alert.warn('Ошибка при получении списка платежей');
        } finally {
            this.loadingPaymentsList = false;
            // this.loadingMoreContent = false;
            // this.isLoading = false;
        }
    }

    public isBlockYeer(index: number): boolean {
        return (
            (this.paymentsList &&
                this.paymentsList[index] &&
                this.paymentsList[index - 1] &&
                this.paymentsList[index].dtSort?.getFullYear() !==
                    this.paymentsList[index - 1].dtSort?.getFullYear()) ||
            index === 0
        );
    }

    public getYeer(index: number): string {
        if (this.paymentsList && this.paymentsList[index]) {
            return this.paymentsList[index].dtSort?.getFullYear() + '';
        } else {
            return '';
        }
    }

    public getFullDateTime(dt: Date): string {
        return formatUiDateTime(dt);
    }

    public getTekDay(dt: Date | null | undefined): string {
        return dt ? getTekDay(dt) : '';
    }

    public getNameDay(dt: Date | undefined): string {
        return getNameDay(dt);
    }

    public getTime(dt: Date | null | undefined): string {
        return dt ? getTime(dt) : '';
    }

    /** Возможна ли оплата */
    public isPay(pay: IPayment): boolean {
        return (
            [1, 2].includes(pay.paymentStatus) &&
            this.paySystem !== null &&
            pay.canPay
        );
    }

    /** Возможен ли возврат */
    public isRefund(pay: IPayment): boolean {
        return pay.paymentStatus === 3;
    }

    public actionClick(pay: IPayment) {
        if (this.isPay(pay)) {
            this.openPaymentModal(pay);
        } else if (this.isRefund(pay)) {
            this.toRefund(pay);
        } else {
            this.alert.info('В данный момент платежная система недоступна');
        }
    }
    /** Модальное окно с вводом почты и телефона */
    public openPaymentModal(pay: IPayment) {
        const certainPS =
            this.paySystem?.data?.find((ps) => ps.systemLpuId === pay.lpuId) ??
            (this.paySystem?.data?.length === 1
                ? this.paySystem?.data[0]
                : null);
        const emailRequiredForPay = certainPS?.requiredFields.includes('email')
            ? true
            : false;
        const phoneRequiredForPay = certainPS?.requiredFields.includes('phone')
            ? true
            : false;

        const dialogRef = this.dialog.open(PatInfoForPayModalComponent, {
            data: {
                sum: pay.allAmount,
                emailRequiredForPay: emailRequiredForPay,
                phoneRequiredForPay: phoneRequiredForPay,
                initialEmail: this._patient.email || '',
                initialPhone:
                    this._patient.phone || this._patient.cellular || '',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.payParam.email = result.email;
                this.payParam.phone = result.phone;
                this.toPay(pay);
            }
        });
    }

    /** Оплатить*/
    public async toPay(pay: IPayment) {
        try {
            if (this.isPay(pay)) {
                if (pay.confirmationUrl && pay.confirmationUrl.length > 5) {
                    window.open(pay.confirmationUrl);
                } else {
                    this.loadingPaymentsList = true;

                    const confirmation_url = await this.createPay(pay);

                    if (confirmation_url) {
                        window.open(confirmation_url);
                    }
                }
            }
        } catch (error) {
            this.alert.error(
                'Ошибка открытия платежа, попробуйте повторить операцию позднее.',
            );
        } finally {
            this.loadingPaymentsList = false;
        }
    }

    public async createPay(pay: IPayment) {
        let confirmation_url: string | null = null;

        try {
            const newPay = await lastValueFrom(
                this.rs.getPaymentTemp(
                    pay.ptKeyId,
                    this.payParam.email,
                    this.payParam.phone,
                ),
            );

            if (newPay.identity && newPay.identity > 0) {
                const newPayOrder = await lastValueFrom(
                    this.paymentsService.getPayOrder(newPay.identity),
                );

                if (newPayOrder.confirmationUrl) {
                    confirmation_url = newPayOrder.confirmationUrl;
                } else {
                    throw new Error('В payOrder отсутствует confirmationurl.');
                }
            } else {
                throw new Error('Не удалось создать платеж');
            }
        } catch (error: unknown) {
            this.alert.error(
                Utils.getErrorMessage(
                    error,
                    'Ошибка создания платежа, попробуйте повторить операцию позднее.',
                ),
            );
        }

        return confirmation_url;
    }

    public toRefund(pay: IPayment) {
        const dialogOpenOptions: MatDialogConfig = {
            data: pay,
            panelClass: 'refund-panel-class',
        };

        this.dialog.open(RefundComponent, dialogOpenOptions);
    }

    /** Строку в число */
    public numberOnlyReplace(str: string): number {
        let resNum = '';
        let i = 0;
        let charCode = 0;
        for (i = 0; i < str.length; i++) {
            charCode = str.charCodeAt(i);
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode != 46
            ) {
            } else {
                resNum = resNum + str[i];
            }
        }
        return Number(resNum);
    }

    /** Оплата */
    public async goPay(p: IPay) {
        try {
            const info = await lastValueFrom(
                this.paymentsService.createPayment(
                    22,
                    p.sum,
                    p.email,
                    p.phone,
                    null,
                ),
            );

            if (!info.identity)
                throw new Error(
                    'Ошибка создания платежа в системе. Проверьте данные и попробуйте снова',
                );

            const payOrder = await lastValueFrom(
                await this.paymentsService.getPayOrder(info.identity),
            );

            if (!payOrder.confirmationUrl) {
                throw new Error(
                    'Ошибка создания платежа в системе. Проверьте данные и попробуйте снова',
                );
            }

            window.location.href = payOrder.confirmationUrl;
        } catch (error: any) {
            this.alert.warn(
                'Ошибка создания платежа в системе. Проверьте данные и попробуйте снова.',
                10000,
            );
        }
    }

    /** Событие выбора страницы */
    public async changedPage(page: any) {
        this.loadingPaymentsList = true;

        if (page === 1) {
            await this.getPayments(1, this.countRectoPage);
        } else {
            await this.getPayments(
                page * this.countRectoPage - this.countRectoPage + 1,
                page * this.countRectoPage,
            );
        }

        this.page = page;
    }

    public showHideListservices(indexPay: number) {
        // Проверка на количество услуг
        if (
            this.paymentsList &&
            this.paymentsList[indexPay].services &&
            this.paymentsList[indexPay].services.length > 1
        ) {
            this.animateStateServices.forEach((item, i_item) => {
                // Скрываем все
                if (i_item != indexPay) {
                    this.animateStateServices[indexPay] === 'off';
                } else {
                }
            });

            if (this.animateStateServices[indexPay]) {
                if (this.animateStateServices[indexPay] === 'off') {
                    this.animateStateServices[indexPay] = 'on';
                } else {
                    this.animateStateServices[indexPay] = 'off';
                }
            }
        }
    }

    public getShowHideServices(indexPay: number): string {
        let def = 'off';
        def = this.animateStateServices[indexPay];
        return def;
    }

    /*    Дата услуг(и)  */
    public getDTSer(d: Date | null): string {
        if (d) {
            return formatUiDate(d);
        } else {
            return '';
        }
    }

    public getPeriodServicesStartEnd(
        services: Array<IFormatedArrayWithService>,
        isStart = true,
    ): string {
        let dt = '';
        // Сортировка
        services.sort((a, b) => {
            if (a.dt && b.dt && a.dt > b.dt) {
                return 1;
            } else {
                return -1;
            }
        });
        const len = services.length;

        const i = isStart ? 0 : len - 1;
        if (services[0].dt && services[len - 1].dt) {
            if (
                services[0].dt.getFullYear() ==
                services[len - 1].dt?.getFullYear()
            ) {
                dt = formatUiDate(services[i].dt);
            } else {
                dt = formatUiDate(services[i].dt);
            }
        } else {
            if (services[i].dt) {
                dt = formatUiDate(services[i].dt);
            }
        }

        return dt;
    }

    public getStrEndServ(count: number): string {
        return getStrEnd(count, 'услуг', ['а', 'и', '']);
    }
    public scrollPosition: any;
    @HostListener('window:scroll', ['$event'])
    public onScroll(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();

        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            if (this.isMobile) {
                // Мобильная версия - проверяем общий скролл страницы
                const scrollPosition = window.pageYOffset;
                const windowSize = window.innerHeight;
                const bodyHeight = document.body.offsetHeight;

                if (
                    !this.loadingMoreContent &&
                    this.loadedPages < this.countOfPages &&
                    scrollPosition + windowSize >= bodyHeight - 100
                ) {
                    this.loadNextPage();
                }
            } else {
                // Десктопная версия - проверяем скролл контейнера
                const paymentsContainer = document.querySelector(
                    '.payments-table__body',
                );
                if (!paymentsContainer) return;

                // Проверяем, что не идет загрузка и есть еще данные для загрузки
                if (
                    this.loadingMoreContent ||
                    this.loadingPaymentsList ||
                    !this.paymentsList ||
                    this.paymentsList.length >= this.paymentsListLength
                ) {
                    return;
                }

                const containerRect = paymentsContainer.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const isNearBottom = containerRect.bottom <= windowHeight + 100;

                if (isNearBottom) {
                    // Для десктопа используем существующую логику загрузки
                    this.loadNextPageForDesktop();
                }
            }
        }, 200);
    }
    private async loadNextPageForDesktop() {
        if (
            this.loadingPaymentsList ||
            !this.paymentsList ||
            this.paymentsList.length >= this.paymentsListLength
        ) {
            return;
        }

        try {
            this.loadingPaymentsList = true;
            this.loadingMoreContent = true;
            const nextPage =
                Math.floor(this.paymentsList.length / this.countRectoPage) + 1;
            const startIndex = (nextPage - 1) * this.countRectoPage + 1;
            const endIndex = nextPage * this.countRectoPage;

            // Сохраняем текущие данные
            const currentPayments = [...this.paymentsList];

            // Загружаем новую страницу
            await this.getPayments(startIndex, endIndex);

            // Объединяем с существующими данными
            if (this.paymentsList && this.paymentsList.length > 0) {
                this.paymentsList = [...currentPayments, ...this.paymentsList];
            } else {
                this.paymentsList = currentPayments;
            }
        } catch (error) {
            console.error('Error loading next desktop page:', error);
            this.alert.error('Не удалось загрузить данные', 3000);
        } finally {
            this.loadingPaymentsList = false;
            this.loadingMoreContent = false;
        }
    }
    public isLastPayment(index: number): boolean {
        return this.paymentsList
            ? index === this.paymentsList.length - 1
            : false;
    }
}
